import styled from 'styled-components'
import { ReactNode } from 'react'

interface PopupWrapperProps {
  inline?: boolean
  children?: ReactNode
}

export const PopupWrapper = styled(({ inline, ...rest }: PopupWrapperProps) => (
  <div {...rest} />
))`
  display: ${({ inline }) => (inline ? 'inline' : 'flex')};

  .content {
    white-space: pre-wrap !important;
  }
`
